export type GetAudioContextOptions = AudioContextOptions & { id?: string };

const audioCtxMap: Map<string, AudioContext> = new Map();

export const audioContext = (async (options?: GetAudioContextOptions) => {
  const didInteract = new Promise((res) => {
    window.addEventListener('pointerdown', res, { once: true });
    window.addEventListener('keydown', res, { once: true });
  });

  try {
    const a = new Audio();
    a.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
    await a.play();
  } catch {
    await didInteract;
  }

  if (options?.id && audioCtxMap.has(options.id)) {
    const ctx = audioCtxMap.get(options.id);
    if (ctx) return ctx;
  }

  const ctx = new AudioContext(options);
  if (options?.id) audioCtxMap.set(options.id, ctx);
  return ctx;
}) as (options?: GetAudioContextOptions) => Promise<AudioContext>;

export const blobToJSON = (blob: Blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        try {
          const json = JSON.parse(reader.result as string);
          resolve(json);
        } catch (e) {
          reject(e);
        }
      } else {
        reject(new Error('No data'));
      }
    };
    reader.readAsText(blob);
  });

export function base64ToArrayBuffer(base64: string) {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

